import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'prompt-color-box',
  templateUrl: './prompt-color-box.component.html',
  styleUrl: './prompt-color-box.component.scss'
})
export class PromptColorBoxComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
